
import styled from "styled-components";
import Button from "../../../Button";


export const TransferBuyButton = styled(Button)`
  margin-right: 15px;
`;
